import { render, staticRenderFns } from "./CalificacionesRecursos.vue?vue&type=template&id=0fee20c7"
import script from "./CalificacionesRecursos.vue?vue&type=script&lang=js"
export * from "./CalificacionesRecursos.vue?vue&type=script&lang=js"
import style0 from "./CalificacionesRecursos.vue?vue&type=style&index=0&id=0fee20c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports